import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/fmp.css';

const TIPOS_ANALISE = [
  { value: 'servico',   label: 'Serviço / Consultivo (Contabilidade, BPO, Fiscal, DP)' },
  { value: 'comercial', label: 'Comercial / Vendas' },
  { value: 'cs',        label: 'CS / Retenção' },
];

const SETORES = ['Contábil', 'BPO Financeiro', 'Fiscal', 'Departamento Pessoal', 'Comercial', 'CaaS', 'Tecnologia', 'Marketing', 'CS'];

const ConfiguracaoCalendario = () => {
  const [conectado, setConectado]     = useState(false);
  const [infoConexao, setInfoConexao] = useState(null);
  const [loading, setLoading]         = useState(true);
  const [tipoAnalise, setTipoAnalise] = useState('');
  const [setorOperador, setSetorOperador] = useState('');
  const [ehAdm, setEhAdm] = useState(false);
  // Guardam o que já está definido no banco: depois de definido, só adm altera
  const [tipoDefinido, setTipoDefinido] = useState(false);
  const [setorDefinido, setSetorDefinido] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    verificarConexao();
    carregarTipoAnalise();
    carregarGrupo();
  }, []);

  const carregarGrupo = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setEhAdm((response.data.grupo || '').toLowerCase().trim() === 'adm');
    } catch (error) {
      console.error('Erro ao verificar grupo:', error);
    }
  };

  const carregarTipoAnalise = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/tipo-analise/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        if (response.data.tipo_analise) {
          setTipoAnalise(response.data.tipo_analise);
          setTipoDefinido(true);
        }
        if (response.data.setor) {
          setSetorOperador(response.data.setor);
          setSetorDefinido(true);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar tipo de análise:', error);
    }
  };

  const salvarTipoAnalise = async (tipo) => {
    setTipoAnalise(tipo);
    if (!tipo) return;
    const accessToken = localStorage.getItem('access');
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/tipo-analise/`,
        { tipo },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
    } catch (error) {
      console.error('Erro ao salvar tipo de análise:', error);
    }
  };

  const salvarSetor = async (setor) => {
    setSetorOperador(setor);
    if (!setor) return;
    const accessToken = localStorage.getItem('access');
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/tipo-analise/`,
        { setor },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
    } catch (error) {
      console.error('Erro ao salvar setor:', error);
    }
  };

  const verificarConexao = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/verificar-conexao-calendar/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setConectado(response.data.conectado);
      setInfoConexao(response.data);
    } catch (error) {
      console.error('Erro ao verificar conexão:', error);
    } finally {
      setLoading(false);
    }
  };

  const conectarGoogleCalendar = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/oauth-iniciar/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        const popup = window.open(
          response.data.authorization_url,
          'Google Calendar Authorization',
          'width=600,height=700,left=200,top=100'
        );
        const checkPopup = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkPopup);
            setTimeout(() => verificarConexao(), 1000);
          }
        }, 500);
      }
    } catch (error) {
      alert('Erro ao iniciar autorização: ' + (error.response?.data?.erro || error.message));
    }
  };

  if (loading) {
    return (
      <div className="container-fluid mt-4">
        <div className="text-center py-5">
          <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }}></div>
          <p className="text-muted">Verificando conexão...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4">
      {/* Header — mesmo padrão da Posicao_cliente.js */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fab fa-google header-icon me-3"></i>
                    <h2 className="titulo-pagina m-0">Integração com o Google</h2>
                  </div>
                  <p className="mb-1 opacity-75">
                    <i className="fas fa-calendar-check me-2"></i>
                    Autorize suas reuniões e sua agenda para a Memor.IA ler as gravações e criar tarefas automaticamente
                  </p>
                </div>

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-light"
                    onClick={() => navigate('/ListaReunioes')}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Conteúdo ── */}
      <div className="row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-10">

          {/* ── Estado: NÃO conectado ── */}
          {!conectado ? (
            <>
              {/* Card de conexão */}
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white">
                      <h5 className="card-title mb-0">
                        <i className="fab fa-google me-2 text-primary"></i>
                        Autorizar Reuniões e Agenda
                      </h5>
                    </div>
                    <div className="card-body p-5 text-center">
                      <div style={{
                        width: 90, height: 90,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 1.5rem',
                        boxShadow: '0 8px 24px rgba(66,133,244,0.35)',
                      }}>
                        <i className="fab fa-google" style={{ color: '#fff', fontSize: '2.4rem' }}></i>
                      </div>

                      <h4 className="fw-bold mb-2">Autorize suas Reuniões e sua Agenda</h4>
                      <p className="text-muted mb-4" style={{ maxWidth: 460, margin: '0 auto 1.5rem', fontSize: '1.05rem' }}>
                        Ao conectar, você faz a autorização das suas <strong>reuniões gravadas</strong> (para
                        a Memor.IA ler e analisar) e da sua <strong>agenda</strong> (para as tarefas serem
                        criadas automaticamente). Tudo em uma única autorização.
                      </p>

                      {/* Setor e tipo de análise — obrigatórios antes de autorizar */}
                      <div className="mb-3" style={{ maxWidth: 460, margin: '0 auto' }}>
                        <label className="form-label fw-semibold">
                          <i className="fas fa-building me-2" style={{ color: '#d610b5' }}></i>
                          De qual setor você é?
                        </label>
                        <select
                          className="form-select"
                          value={setorOperador}
                          disabled={setorDefinido && !ehAdm}
                          onChange={(e) => salvarSetor(e.target.value)}
                        >
                          <option value="">— selecione o seu setor —</option>
                          {SETORES.map(s => (
                            <option key={s} value={s}>{s}</option>
                          ))}
                        </select>
                        <small className="text-muted d-block mt-1">
                          {setorDefinido && !ehAdm
                            ? <><i className="fas fa-lock me-1"></i>Setor já definido — alteração restrita ao administrador.</>
                            : 'Usado nos painéis de gestão para agrupar as análises por setor.'}
                        </small>
                      </div>

                      <div className="mb-4" style={{ maxWidth: 460, margin: '0 auto' }}>
                        <label className="form-label fw-semibold">
                          <i className="fas fa-sitemap me-2" style={{ color: '#d610b5' }}></i>
                          Qual o seu tipo de atendimento?
                        </label>
                        <select
                          className="form-select"
                          value={tipoAnalise}
                          disabled={tipoDefinido && !ehAdm}
                          onChange={(e) => salvarTipoAnalise(e.target.value)}
                        >
                          <option value="">— selecione o tipo —</option>
                          {TIPOS_ANALISE.map(t => (
                            <option key={t.value} value={t.value}>{t.label}</option>
                          ))}
                        </select>
                        <small className="text-muted d-block mt-1">
                          {tipoDefinido && !ehAdm
                            ? <><i className="fas fa-lock me-1"></i>Tipo já definido — alteração restrita ao administrador.</>
                            : 'Isso define como a Memor.IA vai avaliar as suas reuniões.'}
                        </small>
                      </div>

                      <button
                        className="btn btn-lg"
                        onClick={conectarGoogleCalendar}
                        disabled={!tipoAnalise || !setorOperador}
                        title={!tipoAnalise || !setorOperador ? 'Selecione o seu setor e o tipo de atendimento antes de autorizar' : ''}
                        style={{
                          background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
                          border: 'none', color: '#fff', borderRadius: 12,
                          padding: '0.75rem 2rem', fontWeight: 600,
                          boxShadow: '0 4px 16px rgba(66,133,244,0.35)',
                          opacity: (!tipoAnalise || !setorOperador) ? 0.6 : 1,
                        }}
                      >
                        <i className="fab fa-google me-2"></i>
                        Autorizar Reuniões + Agenda
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card "Como funciona" */}
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white">
                      <h5 className="card-title mb-0">
                        <i className="fas fa-info-circle me-2 text-primary"></i>
                        Como funciona
                      </h5>
                    </div>
                    <div className="card-body">
                      {[
                        { num: 1, icon: 'fa-key',           cor: '#00205b', texto: 'Você autoriza com sua conta Google (apenas uma vez) — agenda e reuniões' },
                        { num: 2, icon: 'fa-folder-open',    cor: '#4285f4', texto: 'Suas reuniões gravadas ficam disponíveis para análise automaticamente' },
                        { num: 3, icon: 'fa-brain',          cor: '#d610b5', texto: 'A Memor.IA analisa a reunião e identifica tarefas e responsáveis' },
                        { num: 4, icon: 'fa-calendar-plus',  cor: '#34a853', texto: 'As tarefas são criadas na sua agenda, com lembretes por e-mail e no celular' },
                      ].map(({ num, icon, cor, texto }) => (
                        <div key={num} className="d-flex align-items-start gap-3 mb-3">
                          <div style={{
                            width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
                            background: `${cor}18`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}>
                            <i className={`fas ${icon}`} style={{ color: cor, fontSize: '1rem' }}></i>
                          </div>
                          <div style={{ paddingTop: 6 }}>
                            <span className="text-muted" style={{ fontSize: '1.05rem' }}>{texto}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (

            /* ── Estado: conectado ── */
            <>
              {/* Card de sucesso */}
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white">
                      <h5 className="card-title mb-0">
                        <i className="fab fa-google me-2 text-success"></i>
                        Status da Conexão
                      </h5>
                    </div>
                    <div className="card-body p-5 text-center">
                      <div style={{
                        width: 90, height: 90, borderRadius: '50%',
                        background: 'linear-gradient(135deg, #28a745, #20c997)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 1.5rem',
                        boxShadow: '0 8px 24px rgba(40,167,69,0.35)',
                      }}>
                        <i className="fas fa-check" style={{ color: '#fff', fontSize: '2.4rem' }}></i>
                      </div>

                      <h4 className="fw-bold text-success mb-2">Conta Google Conectada!</h4>
                      <p className="text-muted mb-0" style={{ fontSize: '1.05rem' }}>
                        Suas reuniões estão autorizadas para leitura e as tarefas serão
                        criadas automaticamente na sua agenda.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card de informações da conexão */}
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white">
                      <h5 className="card-title mb-0">
                        <i className="fas fa-user-circle me-2 text-primary"></i>
                        Informações da Conexão
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="p-3 rounded-3" style={{ background: '#f8f9fa' }}>
                            <small className="text-muted d-block mb-1">
                              <i className="fas fa-user me-1"></i>Nome
                            </small>
                            <strong>{infoConexao?.nome}</strong>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="p-3 rounded-3" style={{ background: '#f8f9fa' }}>
                            <small className="text-muted d-block mb-1">
                              <i className="fas fa-envelope me-1"></i>E-mail
                            </small>
                            <strong>{infoConexao?.email}</strong>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="p-3 rounded-3" style={{ background: '#f8f9fa' }}>
                            <small className="text-muted d-block mb-1">
                              <i className="fas fa-clock me-1"></i>Conectado em
                            </small>
                            <strong>
                              {infoConexao?.conectado_em
                                ? new Date(infoConexao.conectado_em).toLocaleString('pt-BR')
                                : '—'}
                            </strong>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="p-3 rounded-3" style={{ background: '#f8f9fa' }}>
                            <small className="text-muted d-block mb-1">
                              <i className="fas fa-building me-1"></i>Setor
                            </small>
                            {(setorDefinido && !ehAdm) ? (
                              <strong>{setorOperador || '—'}</strong>
                            ) : (
                              <select
                                className="form-select form-select-sm"
                                value={setorOperador}
                                onChange={(e) => salvarSetor(e.target.value)}
                              >
                                <option value="">— selecione —</option>
                                {SETORES.map(s => (
                                  <option key={s} value={s}>{s}</option>
                                ))}
                              </select>
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="p-3 rounded-3" style={{ background: '#f8f9fa' }}>
                            <small className="text-muted d-block mb-1">
                              <i className="fas fa-sitemap me-1"></i>Tipo de análise
                            </small>
                            {(tipoDefinido && !ehAdm) ? (
                              <strong>{TIPOS_ANALISE.find(t => t.value === tipoAnalise)?.label || tipoAnalise || '—'}</strong>
                            ) : (
                              <select
                                className="form-select form-select-sm"
                                value={tipoAnalise}
                                onChange={(e) => salvarTipoAnalise(e.target.value)}
                              >
                                <option value="">— selecione —</option>
                                {TIPOS_ANALISE.map(t => (
                                  <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                              </select>
                            )}
                            {(setorDefinido || tipoDefinido) && !ehAdm && (
                              <small className="text-muted d-block mt-1">
                                <i className="fas fa-lock me-1"></i>
                                Para alterar o setor ou o tipo de análise, fale com o administrador.
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Ações */}
              <div className="d-flex gap-3 justify-content-center mb-4">
                <button
                  className="btn btn-outline-primary"
                  onClick={conectarGoogleCalendar}
                  style={{ borderRadius: 10, padding: '0.6rem 1.5rem' }}
                >
                  <i className="fas fa-sync me-2"></i>Reconectar
                </button>
                <button
                  className="btn btn-light border"
                  onClick={() => navigate('/ListaReunioes')}
                  style={{ borderRadius: 10, padding: '0.6rem 1.5rem' }}
                >
                  <i className="fas fa-arrow-left me-2"></i>Voltar
                </button>
              </div>
            </>
          )}

        </div>
      </div>

    </div>
  );
};

export default ConfiguracaoCalendario;
